import config from 'fabscale-app/config/environment';

export default function appVersion(): string {
  return config.version;
}
